import { map } from 'rxjs/operators';
import { Service } from '../models/service';
import * as _ from 'underscore';
import { Observable } from 'rxjs';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { TreeNode } from 'primeng/api';
import { ServiceDto } from '@shared/interfaces/dtos/services';

export class ServiceTreeUtils {
  /**
   * @deprecated Uses `underscore.js` (`_.uniq`, `_.sortBy`), untyped `any[]` arrays, and nested mutable mutations.
   * Use `toTreeNodes()` for tree building and standard array methods instead of underscore.
   */
  public static handleServices(adminService: iAdminService, mine: boolean = false): Observable<any> {
    return adminService[mine ? 'fetchMyOwnServices' : 'getGlobalServices']().pipe(
      map((services: Service[]) => {
        const arrayParent = [];
        const arrayChildren = [];
        let arrayTransformed = [];
        arrayTransformed = [...services];
        arrayTransformed = _.uniq(arrayTransformed, 'id');
        arrayTransformed.map((item, _, arr) => {
          if (item.parentId === 0 || !item.parentId) {
            item.children = [];
            arrayParent.push(item);
          } else {
            item.children = [];

            //Use case when it is a sub service and we don't have access to the parent service
            if (!arr.some((service) => service.id === item.parentId)) {
              arrayParent.push(item);
              return;
            }

            arrayChildren.push(item);
          }
        });
        function recursion(parent, children) {
          children.map((child) => {
            if (parent.id === child.parentId) {
              parent.label = parent.description;
              parent.name = parent.description;
              parent.key = parent.id;
              parent.value = parent.id;
              parent.children.push({
                label: child.description,
                id: child.id,
                value: child.id,
                parentId: parent.id,
                key: child.id,
                children: child.children,
              });
              recursion(child, children);
            } else {
              parent.label = parent.description;
              parent.name = parent.description;
              parent.key = parent.id;
              parent.value = parent.id;
            }
          });
        }
        const serviceParent = arrayParent;
        if (arrayChildren && arrayChildren.length > 0) {
          arrayParent.map((parent) => {
            arrayChildren.map((child) => {
              if (parent.id === child.parentId) {
                parent.label = parent.description;
                parent.name = parent.description;
                parent.key = parent.id;
                parent.value = parent.id;
                parent.children.push({
                  label: child.description,
                  key: child.id,
                  id: child.id,
                  value: child.id,
                  parentId: parent.id,
                  children: child.children,
                });
                recursion(child, arrayChildren);
              } else {
                parent.label = parent.description;
                parent.name = parent.description;
                parent.key = parent.id;
                parent.value = parent.id;
              }
            });
          });
        } else {
          arrayParent.map((parent) => {
            parent.label = parent.description;
            parent.name = parent.description;
            parent.key = parent.id;
            parent.value = parent.id;
          });
        }
        let fusionnedArray = [];
        fusionnedArray = arrayParent.concat(arrayChildren);
        fusionnedArray.map((item) => {
          if (item.parent && item.parent.label) {
            item.name = item.parent.label + ' / ' + item.label;
          } else {
            item.name = item.label;
          }
          item.isGroup = 'non';
        });
        let servicesParentChild = [];
        fusionnedArray.map((item) => {
          if (item.parentId && item.description) {
            let parent = [];
            parent = services.filter((x) => x.id === item.parentId);
            item.label = parent.length > 0 ? parent[0].label + ' / ' + item.description : item.description;
          }
          servicesParentChild.push({
            label: item.label,
            value: item.id,
            hasChildren: item.children.length > 0 ? true : false,
          });
        });
        servicesParentChild = _.sortBy(servicesParentChild, 'label');
        const results = { servicesParentChild, serviceParent, arrayTransformed };
        return results;
      })
    );
  }

  /**
   * @deprecated Untyped parameters, uses `setTimeout` to manipulate the DOM directly, and relies on PrimeNG internal CSS class names.
   * Avoid direct DOM manipulation — handle selection state through PrimeNG component bindings instead.
   */
  public static patchServiceNumberOnLoopInTreeSelect(serviceChosen, serviceParent) {
    const allServicesToBeAdded = [];
    serviceParent.map((parent) => {
      //si le parentId correspond on push
      if (parent.id === serviceChosen) {
        allServicesToBeAdded.push(parent);
      } else {
        //Si pas on va devoir entrer dans les enfants
        if (parent.children && parent.children.length > 0) {
          recursive(serviceChosen, parent.children, allServicesToBeAdded);
        }
      }
    });
    setTimeout(() => {
      const labelTreeHtml = document.getElementsByClassName('p-treeselect-label');
      labelTreeHtml[0].innerHTML = allServicesToBeAdded[0].label;
    }, 500);

    function recursive(serviceId, children, allServicesToBeAdded) {
      children.map((child) => {
        if (child.id === serviceId) {
          allServicesToBeAdded.push(child);
        } else {
          if (child.children && child.children.length > 0) {
            recursive(serviceId, child.children, allServicesToBeAdded);
          }
        }
      });
    }
  }

  public static toTreeNodes(services: ServiceDto[]): TreeNode<ServiceDto>[] {
    const uniqueServices = _.uniq(services, 'id') as ServiceDto[];
    const servicesByParent = new Map<number | null, ServiceDto[]>();

    servicesByParent.set(null, []);

    for (const s of uniqueServices) {
      const parentId = (s.parentId ?? null) as number | null;

      //Use case when it is a sub service and we don't have access to the parent service
      if (s.parentId && !uniqueServices.some((service) => service.id === s.parentId)) {
        servicesByParent.get(null)?.push(s);
        continue;
      }

      if (!servicesByParent.has(parentId)) {
        servicesByParent.set(parentId, []);
      }

      servicesByParent.get(parentId)!.push(s);
    }

    const buildNodes = (parentId: number | null, parentNode?: TreeNode<ServiceDto>): TreeNode<ServiceDto>[] => {
      const list = servicesByParent.get(parentId) ?? [];

      return list.map((service) => {
        const node: TreeNode<ServiceDto> = {
          label: service.description,
          data: { ...service },
          key: service.id.toString(),
          parent: parentNode,
          selectable: true,
        };

        const children = buildNodes(service.id, node);

        if (children.length) {
          node.children = children;
        }

        return node;
      });
    };

    return buildNodes(null);
  }
}
